import Logger from '@/lib/helper/Logger/Logger';
import {DateTime} from 'luxon'

class Transform {
    constructor() {
    }

    transformMoneyToString = (money: string) => {
        money = money.toString().replace(/\./g, ""); //remove dot
        money = money.replace(/\B(?=(\d{3})+(?!\d))/g, "."); //update new dot
        return money
    };

    transformMoneyToNumber = (money: string) => {
        if (money) {
            return parseInt(money.toString().replace(/\./g, ""))
        }
        return 0
    };

    transformDateToString = (date: Date | string, hasTime: boolean = false) => {
        try {
            if (typeof date == 'string') {
                date = new Date(date);
            }
            let dateObject = {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear(),
                hour: date.getHours(),
                minute: date.getMinutes(),
                second: date.getSeconds()
            }

            if (hasTime) {
                return DateTime.fromObject(dateObject).setZone('UTC+7').toFormat('dd/MM/yyyy HH:mm')
            }
            return DateTime.fromObject(dateObject).setZone('UTC+7').toFormat('dd/MM/yyyy')
        } catch (error) {
            return ''
        }


        // let dateString = (
        //     date.getDate() +
        //     "/" +
        //     (date.getMonth() + 1) +
        //     "/" +
        //     date.getFullYear()
        // );
        // let dateTime = dateString
        // if(hasTime){
        //     let timeString = (
        //         date.getHours() + ':' + date.getMinutes()
        //     )
        //     dateTime += " " + timeString
        // }
    }

    transformDateToStringSchedule = (date: any, type: 'start' | 'end') => {
        date = new Date(date)

        let startDate = date.getDate() + "/" + (date.getMonth() + 1)
        let endDate = date.setDate(date.getDate() + 30)
        endDate = new Date(endDate)
        endDate = endDate.getDate() + "/" + (endDate.getMonth() + 1)

        return type == 'start' ? startDate : endDate
    }

    transformToSlug = (title: string) => {
        var slug;

        //Đổi chữ hoa thành chữ thường
        slug = title.toLowerCase();

        //Đổi ký tự có dấu thành không dấu
        slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
        slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
        slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
        slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
        slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
        slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
        slug = slug.replace(/đ/gi, 'd');
        //Xóa các ký tự đặt biệt
        slug = slug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
        //Đổi khoảng trắng thành ký tự gạch ngang
        slug = slug.replace(/ /gi, " - ");
        //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
        //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
        slug = slug.replace(/\-\-\-\-\-/gi, '-');
        slug = slug.replace(/\-\-\-\-/gi, '-');
        slug = slug.replace(/\-\-\-/gi, '-');
        slug = slug.replace(/\-\-/gi, '-');
        //Xóa các ký tự gạch ngang ở đầu và cuối
        slug = '@' + slug + '@';
        slug = slug.replace(/\@\-|\-\@|\@/gi, '');
        slug = slug.replace(/\s/g, '');

        return slug
    }

    transformFileToBase64 = async (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            if (reader) {
                reader.readAsDataURL(file)
                reader.onload = () => {
                    resolve(reader.result?.toString().split(',')[1])
                }
                reader.onerror = reject
            }
        })
    }

    prepareDataForBubbleImageUpload = async (file: any) => {
        let imageBase64: any = await this.transformFileToBase64(file)
        return {private: false, fileName: file.name, contents: imageBase64}
    }

    prepareListOfFileForBubbleImageUpload = async (files: any) => {
        let newFiles: any = []
        for (let file of files) {
            let newFile: any = await this.prepareDataForBubbleImageUpload(file)
            newFile = JSON.stringify(newFile)
            newFiles = [...newFiles, newFile]
        }
        return newFiles
    }

    transformStringToSlug = (str: string) => {
        // Remove accents
        const from = "àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ";
        const to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeiiiiiooooooooooooooooouuuuuuuuuuuyyyyydAAAAAAAAAAAAAAAAAEEEEEEEEEEEIIIIIOOOOOOOOOOOOOOOOOUUUUUUUUUUUYYYYYD";
        let slug = str;
        for (let i = 0; i < from.length; i++) {
            slug = slug.replace(new RegExp(from[i], 'g'), to[i]);
        }

        // Convert to lowercase
        slug = slug.toLowerCase();

        // Remove invalid characters
        slug = slug.replace(/[^a-z0-9\s-]/g, '');

        // Replace whitespace with dashes
        slug = slug.replace(/\s+/g, '-');

        // Remove multiple dashes
        slug = slug.replace(/-+/g, '-');

        // Trim dashes from the start and end
        slug = slug.replace(/^-+|-+$/g, '');

        return slug;
    }

    async transformEkycDateToDate(logger: any, inputDate: string) {
        try {
            await logger.debug('EKYC NEST TRANSFORM DATE', inputDate)

            // Split the string to extract day, month, and year
            const [day, month, year] = inputDate.split('/');

            // Create a new Date object
            const dateObject = new Date(`${year}-${month}-${day}`);

            // Format the date for MySQL (YYYY-MM-DD)
            return dateObject.toISOString().split('T')[0];
        } catch (error: any) {
            await logger.error('EKYC NEST TRANSFORM DATE', error.message || error.response?.message || error.data?.message || 'Vui lòng thử lại')
            throw error
        }
    }

    getFileFromUrl = async (url: string, fileName: string = '') => {
        // Fetch the image from the URL
        const response = await fetch(url);

        // Ensure the request was successful
        if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`);
        }

        // Convert the response to a Blob
        const blob = await response.blob();

        // Create a File object from the Blob
        return new File([blob], fileName, { type: 'image/png' });
    }
}

export default Transform;
